<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        {{this.Filter.EmpType === 'front'? 'Approval Details Front Report':'Approval Details Back Report'}}
    </div>
    <form name="ApprovalDetails" (ngSubmit)="Validate(ApprovalDetails)" #ApprovalDetails="ngForm" class="pb-2"
        novalidate>
        <div class="card-body">
            <div class="row d-flex">
                <div class="col-md-4 px-1">
                    <label class="form-label">Manual/ Pre OnBoarding<span
                            class="text-danger">*</span></label><br>
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-2" ngbButtonLabel
                            *ngFor="let pc of ManualPreOnboarding">
                            <input class="form-check-input" type="radio" [value]="pc.Value"
                                name='makercheckeroption' [(ngModel)]="Filter.SelectType"
                                [ngModelOptions]="{standalone: true}">
                            {{pc.Label}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-md-3 px-1">
                    <label class="Label"> From Date </label>
                    <div class="input-group">
                        <input class="form-control" placeholder="yyyy-mm-dd" name="fromdate "
                            placeholder="Ex. DD/MM/YYYY" [(ngModel)]="Filter.FromDateObj" #HolidayDate="ngModel"
                            ngbDatepicker #d="ngbDatepicker" [ngModelOptions]="{standalone: true}" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please enter from date !
                        </div>
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label class="Label"> To Date </label>
                    <div class="input-group">
                        <input class="form-control" placeholder="yyyy-mm-dd" name="todate " placeholder="Ex. DD/MM/YYYY"
                            [(ngModel)]="Filter.ToDateObj" #HolidayDate="ngModel" ngbDatepicker #d1="ngbDatepicker"
                            [ngModelOptions]="{standalone: true}" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please enter from date !
                        </div>
                    </div>
                </div>
                <div class="col-md-5 px-1">
                    <label class="form-font-label">Branch</label>
                    <ng-select name="Branchmaster" id="Branchmaster" [items]="BranchMaster" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Filter.BranchId"
                        (change)="ComboLoad('Client');onSelectChange('Branch')" #Branchmaster="ngModel"
                        placeholder="Select Branch">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch!
                    </div>
                </div>
                <div class="col-md-6 px-1" *ngIf="Filter.EmpType === 'front'">
                    <label class="form-font-label">Client</label>
                    <ng-select name="Client" id="Client" [items]="ClientMaster" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" (change)="ComboLoad('Site');onSelectChange('Client')"
                        [(ngModel)]="Filter.ClientId" #Branch="ngModel" placeholder="Select Client">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Client!
                    </div>
                </div>
                <div class="col-md-7 px-1" *ngIf="Filter.EmpType === 'front'">
                    <label class="form-font-label">Site</label>
                    <ng-select name="Site" id="Site" [items]="SiteMaster" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Filter.SiteId" #Branch="ngModel" (change)="onSelectChange('Site')"
                        placeholder="Select Site">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Site!
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label class="Label">Approval Type<span class="text-danger">*</span></label>
                    <ng-select name="allocationtype" [(ngModel)]="Filter.ApprovalStatus"
                        placeholder="Select Approval Type" required> 
                        <ng-option [value]="'All'">
                            All
                        </ng-option>
                        <ng-option [value]="'Approved'">
                            Approved
                        </ng-option>
                        <ng-option [value]="'Rejected'">
                            Rejected
                        </ng-option>
                        <ng-option [value]="'Pending'">
                            Pending
                        </ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Approval Status!
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label>Code </label>
                    <input name="Code" maxlength="100" class="form-control" placeholder="Ex."
                        [(ngModel)]="Filter.EmpCode" #Code="ngModel">
                    <div class="invalid-feedback">
                        Please enter Code.
                    </div>
                </div>
                <div class="col-md-2 px-1 d-flex align-items-end">
                    <button *ngIf="this.common.PageRight.IsPrint" type="submit" name="submit1" class="btn btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel' : 'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>